import { useMutation } from '@apollo/client';
import { GRAPHQL_ALTERNANCIA_ATIVO_USUARIO } from 'gql/usuario';
import { useCallback } from 'react';

export const useMutationToggleActive = () => {
    const [toggleActive, { loading: loadingToogleActive }] = useMutation(
        GRAPHQL_ALTERNANCIA_ATIVO_USUARIO
    );
    const handleToogleActive = useCallback(
        ({ id, ativo }) => {
            toggleActive({
                variables: { usuarioId: id, ativo: !ativo },
            });
        },
        [toggleActive]
    );
    return {
        handleToogleActive,
        loadingToogleActive,
    };
};
